import { HeaderComponent } from './header/header.component';
import { UserInfoComponent } from './user-info/user-info.component';
import { AccountSwitcherComponent } from './account-switcher/account-switcher.component';
import {NotFoundPageComponent} from "~core/components/not-found-page/not-found-page.component";

export const Components = [
	HeaderComponent,
	UserInfoComponent,
	AccountSwitcherComponent,
	NotFoundPageComponent
];
